import { Box, Container, Flex } from 'components/box';
import SectionTitle from 'components/_shared/elements/section-title';
import { css } from '@emotion/react';
import { Link } from 'components/configurable-routing';
import { Text } from 'components/typography';
import { PageLayoutSeoHeader } from 'types/types';
import { Fragment } from 'react';

const SeoHeader = ({ title, breadcrumbs }: PageLayoutSeoHeader) => (
  <Box px={3}>
    <Container
      py={3}
      px={0}
      css={theme => css`
        max-width: ${theme.extendedMaxWidth}px;
      `}
    >
      <Flex
        flexDirection="column"
        css={theme => css`
          gap: ${theme.space[3]}px;
        `}
      >
        {!!breadcrumbs && breadcrumbs.length > 0 && (
          <Flex
            alignItems="center"
            css={theme => css`
              gap: ${theme.space[1]}px;
            `}
          >
            {breadcrumbs.map(({ label, url }, idx) => (
              <Fragment key={`${label}${url ? `-${url}` : ''}`}>
                {idx > 0 && <Text>/</Text>}
                {url ? (
                  <Link href={url} fontWeight="normal">
                    {label}
                  </Link>
                ) : (
                  <Text>{title}</Text>
                )}
              </Fragment>
            ))}
          </Flex>
        )}

        <SectionTitle title={title} pageTitle />
      </Flex>
    </Container>
  </Box>
);

export default SeoHeader;
